module.exports = __webpack_public_path__ + "307e5dac64047d7a8b67a239cc10ec64.svg";